import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { SubmissionError, FieldArray } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import Box from '../components/Box'
import ErrorMessage from '../components/ErrorMessage'
import { fetchCustomerPDA, updateCustomerPDA } from '../actions/customers'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'
import { fetchOperators } from '../actions/operators'

class CustomerPDAEditForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }
    this.submit = this.submit.bind(this)
    this.load = this.load.bind(this)
  }

  componentDidMount() {
    const { customers, fetchCustomerPDA, match, fetchOperators } = this.props
    
    fetchOperators()

    if (!customers.customer) {
      fetchCustomerPDA(match.params.id)
    } else {
      this.setState({ loaded: true })
    }    
    
    this.load(this.props)
  }

  load(props) {
    const { operators } = props

    if (!this.state.loaded &&
      operators) {

      this.setState({
        loaded: true
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.loaded && nextProps.customers.customer) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    const { updateCustomerPDA, customers } = this.props

    props.Executor = this.props.fullname

    return updateCustomerPDA(customers.customer._id, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { customers, error, pristine, submitting, handleSubmit, operators } = this.props

    if (!this.state.loaded) {
      if (customers.error) {
        return (
          <ErrorMessage message={customers.error.message} />
        )
      }

      return (
        <LoadingProgress />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">EDITAR </span>
          <span className="text-vw-light">USUARIO PDA</span>
        </h1>
        <div className="row">
          <div className="col">
            <Box title="Cliente" icon="user">
              <Field name="Fullname"
                type="text"
                component={renderInputField}
                label="Nombre completo" />
              <Field name="Email"
                type="text"
                component={renderInputField}
                label="E-mail" />
              <Field name="Password"
                type="password"
                component={renderInputField}
                label="Password" />
            </Box>
          </div>
          <div className="col">
            <Box title="Agregador vinculado (Solo Baqueira)" icon="user">
              <Field name="Operator"
                component={renderSelectField}
                label="Agregador">
                {operators &&
                  operators
                    .sort((a, b) => a.Name.localeCompare(b.Name))
                    .map((operator) => (
                      <option value={operator._id} key={operator._id}>
                        {operator.Name}
                      </option>
                    ))}
              </Field>
            </Box>
          </div>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        <button className="btn bg-vw-light text-white mr-1 save" type="submit"
          disabled={pristine || submitting}>
          Guardar
        </button>
      </form>
    )
  }
}

CustomerPDAEditForm = reduxForm({
  form: 'CustomerPDAEditForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/customers/`)
  }
})(CustomerPDAEditForm)

const mapStateToProps = state => ({
  customers: state.customers,
  initialValues: state.customers.customer,
  fullname: state.auth.fullname,
  operators: state.operators.operators,
})

const mapDispatchToProps = dispatch => ({
  fetchCustomerPDA: bindActionCreators(fetchCustomerPDA, dispatch),
  updateCustomerPDA: bindActionCreators(updateCustomerPDA, dispatch),
  fetchOperators: bindActionCreators(fetchOperators, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPDAEditForm)


